<div class="btn-float">
	<i class="bi bi-file-earmark-plus-fill"></i>
</div>
<div class="dashboard-card list-card">
	<div class="widget-header">
		<h5>
			Organizations List
		</h5>

		<div class="col-6">
			<div class="input-group">
				<input type="text" class="form-control" placeholder="Search Organization and Institutes" 
				aria-label="Institute ID" aria-describedby="button-addon2" [(ngModel)]="searchTerm"
				(keyup.enter)="onSearchChange()">
				<button class="btn btn-primary" type="button" id="button-addon2" (click)="onSearchChange()">Search</button>
			</div>
		</div>

		<!-- <button class="btn btn-sm btn-light py-0" data-bs-toggle="modal" data-bs-target="#frmBackdrop" (click)="newClick()">
			+Add New
		</button> -->
	</div>

	<div class="w-100">
		<table id="orgTable" class="table table-striped w-100">
			<thead>
				<tr>
					<th class="col-1 fw-semibold">#</th>
					<th class="col-1 fw-semibold">Code</th>
					<th class="col-6 fw-semibold">Name</th>
					<th class="col-2 fw-semibold">Reg. Date</th>
					<th class="col-1 fw-semibold">Status</th>
					<th class="col-1 fw-semibold">Action</th>
				</tr>
			</thead>
			<tbody>
			@for(data of allData; track $index; let idx = $index;) {
				<tr>
					<td rowspan="2">{{idx+1}}.</td>
					<td>{{data.org_code}}</td>
					<td>{{data.org_name}}</td>
					<td>{{dataService.ymd2dmy(data?.reg_date)}}</td>
					<td>{{data.is_active}}</td>
					<td>
						<div class="d-flex gap-2">
							<span style="cursor: pointer;" (click)="orgConnect(data)" title="Connect"
								 data-bs-toggle="modal" data-bs-target="#staticBackdrop2">
								<i class="bi bi-folder-symlink text-primary"></i>
							</span>

							<span style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#frmBackdrop"
								(click)="editClick(data)" title="Modify">
								<i class="bi bi-pencil-square text-success"></i>
							</span>

							<span style="cursor: pointer;" (click)="deleteClick(data.id)" title="Delete">
								<i class="bi bi-trash3 text-danger"></i>
							</span>
						</div>
					</td>
				</tr>
				@if(data.institutes && data.institutes.length) {
					<tr>
						<td colspan="5">
							<table class="table w-100 my-0">
								<thead>
									<tr>
										<th class="col-1 py-1 fw-medium">#</th>
										<th class="col-1 py-1 fw-medium">Code</th>
										<th class="col-4 py-1 fw-medium">Inst. Name</th>
										<th class="col-2 py-1 fw-medium">Contact</th>
										<th class="col-2 py-1 fw-medium">Pkg. Type</th>
										<th class="col-2 py-1 fw-medium">Pkg. Date</th>
									</tr>
								</thead>
								<tbody>
									@for(inst of data.institutes; track inst; let x = $index;) {
										<td>{{x+1}}.</td>
										<td>{{inst.inst_code}}</td>
										<td>
											{{inst.inst_name}} &nbsp;
											<small class="mx-0 px-0">({{dataService.getInstituteType(inst.inst_type)}})</small>
											<div class="mx-0 px-0 py-0 my-0 blink-text text-danger" *ngIf="inst.reNewAlert">
												@if(inst.dayRemains > 0 && inst.dayRemains < 15) {
													(#<b>{{inst.dayRemains}}</b> days to expire)
												} @else if(inst.dayRemains < 1) {
													(<b>Expired!</b>)
												}
											</div>
										</td>
										<td><i class="bi bi-telephone"></i> {{inst.phone_no}}<br>
										<small>City: {{inst.city}}</small></td>
										<td>
											{{inst.bill_cycle}}<br>
											<small class="badge text-bg-success py-1">{{inst.is_active ? 'Active' : 'Expired'}}</small>
										</td>
										<td>
											<small class="mx-0 px-0">{{dataService.ymd2dmy(inst.start_date)}} to</small><br>
											{{dataService.ymd2dmy(inst.exp_date)}}
										</td>
									}
								</tbody>
							</table>
						</td>
					</tr>
				} @else {
					<tr><td colspan="5">No Institute Found!</td></tr>
				}
			}
			</tbody>
		</table>

		<div class="text-danger" align="center" *ngIf="allData && !allData.length && !loading">
			<i class="bi bi-x-circle"></i> No data available.
		</div>
	</div>
</div>


<div class="offcanvas offcanvas-end" tabindex="-1" id="orgSidePanel" aria-labelledby="orgSidePanelLabel">
	<div class="offcanvas-header">
		<h5 class="offcanvas-title" id="orgSidePanelLabel">{{spTitle}} Book</h5>
		<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
	</div>
	<div class="offcanvas-body py-2">

		@if(spType == 'address' && spOpt == 'list') {
		@for(a of addresses; track $index; let idx=$index;) {
		<div class="card mb-2 bg-light bg-light-subtle" [class.border-primary]="idx==0" title="Default Address">
			<div class="card-body py-1">
				<div class="card-text mb-1">
					Flat #2625-A, Gillco Ext. 5, Gillco Valley, Landra Road,
					Kharar-140301, Dist.: Rupnagar, Punjab, India.
				</div>
				<div class="d-flex align-items-center justify-content-between">
					@if(idx==0) {
					<small class="text-primary">Status: Default</small>
					} @else if(idx==3) {
					<small class="text-danger">Status: Not-Active</small>
					} @else {
					<small class="text-success">Status: Active</small>
					}
					<span>
						<button type="button" class="btn btn-sm btn-link">Edit</button>
						<button type="button" class="btn btn-sm btn-link">Delete</button>
					</span>
				</div>
			</div>
		</div>
		}
		}


	</div>
	<div class="offcanvas-header py-2 gap-2 justify-content-center">
		<button type="button" class="btn btn-sm btn-primary">Add New {{spTitle}}</button>
		<button type="button" class="btn btn-sm btn-outline-secondary" data-bs-dismiss="offcanvas">Cancel</button>
	</div>
</div>

<div class="modal fade" id="frmBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="frmBackdropLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="frmBackdropLabel">Organization Form</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<app-org-form [user]="user" [action]="btnClick"></app-org-form>
			</div>
			<div class="modal-footer">
				<button type="button" class="col-2 btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancel</button>
				<button type="button" class="col-2 btn btn-sm btn-primary" data-bs-dismiss="modal" 
					(click)="btnClick = isEdit ? 'update' : 'save'; reloadData();">
					{{isEdit ? 'Update' : 'Save'}}
				</button>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" id="staticBackdrop2" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="staticBackdropLabel2" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl kyc-body" *ngIf="selOrg && user && user.user_role[0].code=='spr'">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="exampleModalToggleLabel">Institutes View: {{selOrg?.org_name}}</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body" style="height: 92vh;">
				<app-org-view [org]="selOrg"></app-org-view>
			</div>
		</div>
	</div>
</div>
